import React, { Component } from 'react';
import classNames from 'classnames';

import * as Types from 'types';
import { Icon } from 'components/icons/Icon';

type Props = {
  initialFilter?: string;
  onChange: (query: string) => void;
  placeholderText?: string;
} & Types.Styleable;

type State = {
  filter: string;
};

export class PlaylistFilter extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { filter: props.initialFilter || '' };
    this.onChange = this.onChange.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
  }

  componentDidUpdate(_prevProps: Props, prevState: State) {
    if (this.state.filter !== prevState.filter) {
      this.props.onChange(this.state.filter);
    }
  }

  onChange(event: React.BaseSyntheticEvent) {
    this.setState({ filter: event.target.value });
  }

  clearFilter() {
    this.setState({ filter: '' });
  }

  render() {
    const { filter } = this.state;
    const className = classNames(
      {
        'playlist-filter': true,
        'playlist-filter--active': filter.length > 0,
      },
      this.props.className,
    );

    return (
      <div className={className} style={this.props.style}>
        <Icon icon='search' className='translate-into-middle-y' />
        <input
          className='playlist-filter__input'
          placeholder={this.props.placeholderText || 'Filter'}
          onChange={this.onChange}
          value={this.state.filter}
          required
        />
        <button
          type='button'
          className='btn--link translate-into-middle-y playlist-filter__clear'
          onClick={this.clearFilter}
        >
          Clear
        </button>
      </div>
    );
  }
}
